<template>
    <section id="review" class="section review-area bg-overlay ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-7">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-white">Our clients says</h2>
                        <p class="text-white d-none d-sm-block mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.</p>
                        <p class="text-white d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Client Reviews -->
                <div class="client-reviews owl-carousel">
                    <!-- Single Review -->
                    <div class="single-review p-5">
                        <!-- Review Content -->
                        <div class="review-content">
                            <!-- Review Text -->
                            <div class="review-text">
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam est modi amet error earum aperiam, fuga labore facere rem ab nemo possimus cum excepturi expedita. Culpa rerum, quaerat qui non.</p>
                            </div>
                            <!-- Quotation Icon -->
                            <div class="quot-icon">
                                <img class="avatar-sm" src="assets/img/quote.png" alt="">
                            </div>
                        </div>
                        <!-- Reviewer -->
                        <div class="reviewer media mt-3">
                            <!-- Reviewer Thumb -->
                            <div class="reviewer-thumb">
                                <img class="avatar-lg radius-100" src="assets/img/avatar_1.png" alt="">
                            </div>
                            <!-- Reviewer Media -->
                            <div class="reviewer-meta media-body align-self-center ml-4">
                                <h5 class="reviewer-name color-primary mb-2">Junaid Hasan</h5>
                                <h6 class="text-secondary fw-6">CEO, Themeland</h6>
                            </div>
                        </div>
                    </div>
                    <!-- Single Review -->
                    <div class="single-review p-5">
                        <!-- Review Content -->
                        <div class="review-content">
                            <!-- Review Text -->
                            <div class="review-text">
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam est modi amet error earum aperiam, fuga labore facere rem ab nemo possimus cum excepturi expedita. Culpa rerum, quaerat qui non.</p>
                            </div>
                            <!-- Quotation Icon -->
                            <div class="quot-icon">
                                <img class="avatar-sm" src="assets/img/quote.png" alt="">
                            </div>
                        </div>
                        <!-- Reviewer -->
                        <div class="reviewer media mt-3">
                            <!-- Reviewer Thumb -->
                            <div class="reviewer-thumb">
                                <img class="avatar-lg radius-100" src="assets/img/avatar_2.png" alt="">
                            </div>
                            <!-- Reviewer Media -->
                            <div class="reviewer-meta media-body align-self-center ml-4">
                                <h5 class="reviewer-name color-primary mb-2">Yasmin Akter</h5>
                                <h6 class="text-secondary fw-6">Founder, Themeland</h6>
                            </div>
                        </div>
                    </div>
                    <!-- Single Review -->
                    <div class="single-review p-5">
                        <!-- Review Content -->
                        <div class="review-content">
                            <!-- Review Text -->
                            <div class="review-text">
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam est modi amet error earum aperiam, fuga labore facere rem ab nemo possimus cum excepturi expedita. Culpa rerum, quaerat qui non.</p>
                            </div>
                            <!-- Quotation Icon -->
                            <div class="quot-icon">
                                <img class="avatar-sm" src="assets/img/quote.png" alt="">
                            </div>
                        </div>
                        <!-- Reviewer -->
                        <div class="reviewer media mt-3">
                            <!-- Reviewer Thumb -->
                            <div class="reviewer-thumb">
                                <img class="avatar-lg radius-100" src="assets/img/avatar_3.png" alt="">
                            </div>
                            <!-- Reviewer Media -->
                            <div class="reviewer-meta media-body align-self-center ml-4">
                                <h5 class="reviewer-name color-primary mb-2">Md. Arham</h5>
                                <h6 class="text-secondary fw-6">CEO, Themeland</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>